export const normalizeDigits = (s) => (s || '').replace(/[^\d]/g, '').slice(0, 10);